export default "__VITE_ASSET__1804ccd7__"